module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat-error-f90265e9a43f57567124445a2a20d3ff.svg";